import { Box } from '@mui/material';
import { SIS } from './sisTokens';
import type { Pill } from './sisMatchingView';

export function SisPill({ pill }: { pill: Pill }) {
  const colors = SIS.pill[pill.tone];
  return (
    <Box
      component="span"
      data-tone={pill.tone}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0 8px',
        borderRadius: '9999px',
        bgcolor: colors.bg,
        color: colors.fg,
        fontFamily: SIS.font,
        fontSize: 14,
        lineHeight: '24px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
      }}
    >
      {pill.label}
    </Box>
  );
}
